module.exports = __webpack_public_path__ + "img/embedded1.252e2bb7.png";